//Note: Initial state
const obMiniCartState = {
	policies: {
		'customer-mini-cart[age]': false
	},
	button: {
		'checkout-button-mini-cart': true
	},
	link: {
		'cart-link-mini-cart': true
	},
	cartRecommendation: {
		'aria-expanded': true
	} 
};

const handleGTMChecked = (input, state) => {
	return input.setAttribute('data-gtm-state', state);
};

const handleObMiniCartSubmit = (event) => {
	const policies = obMiniCartState.policies;
	const policiesChecked = Object.keys(obMiniCartState.policies).every((key) => policies[key] === true);

	handleObMiniCartErrorMessage(policies);

	if (policiesChecked) {
		return;
	} else {
		event.preventDefault();
		return false;
	}
};

const handleObMiniCartErrorMessage = (policies) => {
	const checkoutButton = document.getElementById('checkout-button-mini-cart') || document.getElementById('cart-link-mini-cart');
	for (const [key, value] of Object.entries(policies)) {
		if (value == false) {
			let policieId = document.getElementById(`${key}`);
			policieId.style.borderColor = '#DE1616';
			policieId.parentNode.setAttribute('checkbox-tooltip', 'Favor preencher a caixa de seleção acima');
			if (checkoutButton) {
				checkoutButton.style.background = '#CCCCCC';
			}
		} else {
			if (checkoutButton) {
				checkoutButton.style.background = '#007E78';
			}
		}
	}
};

const handleObMiniCartCheckBox = (event) => {
	const input = event.target;
	const checkoutButton = document.getElementById('checkout-button-mini-cart') || document.getElementById('cart-link-mini-cart');

	if (input.checked) {
		input.checked = true;
		let policieId = document.getElementById(`${input.id}`);
		policieId.parentNode.removeAttribute('checkbox-tooltip');
		policieId.style.borderColor = '';
		if (checkoutButton) {
			checkoutButton.style.background = '#007E78';
		}
	} else {
		input.checked = false;
		if (checkoutButton) {
			checkoutButton.style.background = '#CCCCCC';
		}
	}
	
	handleGTMChecked(input, input.checked);
	obMiniCartState.policies[input.id] = input.checked;
};

const handleCartRecommendationsOnRerender = () => {
	const fromStateAriaExpanded = obMiniCartState.cartRecommendation['aria-expanded'];
	const checkoutButton = document.getElementById('checkout-button-mini-cart') || document.getElementById('cart-link-mini-cart');
	const cartRecommendation = document.querySelector('cart-drawer-recommendations');
	if (!cartRecommendation) {
		return;
	}
	cartRecommendation.setAttribute('aria-expanded', fromStateAriaExpanded);

	for (const [value] of Object.entries(obMiniCartState.policies)) {
		if (value == false) {
			if (checkoutButton) {
				checkoutButton.style.background = '#CCCCCC';
			}
		} else {
			if (checkoutButton) {
				checkoutButton.style.background = '#007E78';
			}
		}
	}
};

const handleCartRecommendations = (thisElement) => {
	const buttonToggle = thisElement.querySelector('.mini-cart__recommendations-button');
	let domAriaExpanded = (thisElement.getAttribute('aria-expanded') === 'true');
	if (!buttonToggle) {
		return;
	}
	let ready = false;
	let currentIndex = 0;
	handleCartRecommendationsSlider(thisElement, ready, currentIndex);
	buttonToggle.addEventListener('click', () => {
		thisElement.setAttribute('aria-expanded', !domAriaExpanded);
		domAriaExpanded = !domAriaExpanded;
		obMiniCartState.cartRecommendation['aria-expanded'] = domAriaExpanded;
	});
};

//Note: Slider Variables

const handleCartRecommendationsSlider = (thisElement, ready, currentIndex) => {

	if (ready) {
		return;
	}

	const wrapper = thisElement;
	if (!wrapper) {
		return;
	}
	
	const items = thisElement.querySelector('.mini-cart__recommendations-list');
	
	items.addEventListener('scroll', (event) => {
		const wrapperRect = wrapper.getBoundingClientRect();
		const totalWidth = wrapperRect.width;
		const itemRect = items.children[0].getBoundingClientRect();
		const itemWidth = itemRect.width;
		const scrollX = event.target.scrollLeft + (totalWidth - itemWidth);
		const result = parseInt(scrollX / itemWidth);
		currentIndex = result;
		updateDots();
	});

	ready = true;
	const dotsContainer = thisElement.querySelector('.cart-drawer-recommendations__dots');
	const children = items.children;
	const updateScroll = () => {
		const element = children[currentIndex];
		const rect = element.getBoundingClientRect();
		const x = rect.width * currentIndex;
		items.scrollTo(x, 0);
	};

	const updateDots = () => {
		const dots = dotsContainer.children;
		Array.from(dots).forEach((dot, index) => {
			if (currentIndex === index) {
				dot.classList.add('selected');
			} else {
				if (dot.classList.contains('selected')) {
					dot.classList.remove('selected');
				}
			}
		});
	};

	Array.from(children).forEach((element, index) => {
		const dot = document.createElement('div');
		dot.classList.add('cart-drawer-recommendations__nav-dot');
		dot.onclick = () => {
			currentIndex = index;
			updateScroll();
			updateDots(); 
		};

		dotsContainer.appendChild(dot);
	});

	const buttonPrev = thisElement.querySelector('.cart-drawer-recommendations__button-prev');
	buttonPrev.onclick = () => {
		if (currentIndex <= 0) {
			currentIndex = children.length - 1;
		} else {
			currentIndex --;
		}
		updateScroll();
		updateDots();
	};

	const buttonNext = thisElement.querySelector('.cart-drawer-recommendations__button-next');
	
	buttonNext.onclick = () => {
		if (currentIndex >= children.length - 1) {
			currentIndex = 0;
		} else { 
			currentIndex ++;
		}
		updateScroll();
		updateDots();
	};

	updateDots();

};

document.addEventListener('cart-drawer-recommendations:loaded', (event) => {
	const { thisElement } = event.detail;
	if (!thisElement) {
		return;
	}
	handleCartRecommendations(thisElement);
});

document.addEventListener('mini-cart:toggle', () => {
	Object.keys(obMiniCartState.policies).forEach((key) => {
		const input = document.getElementById(key);
		const checkoutButton = document.getElementById('checkout-button-mini-cart') || document.getElementById('cart-link-mini-cart');
		
		if (!input) {
			return;
		} else if (input.checked) {
			if (checkoutButton) {
				checkoutButton.style.background = '#007E78';
			}
		}

		obMiniCartState.policies[input.id] = input.checked;
		input.removeEventListener('click', handleObMiniCartCheckBox);
		input.addEventListener('click', handleObMiniCartCheckBox);
	});

	Object.keys(obMiniCartState.button).forEach((key) => {
		const button = document.getElementById(key);
		if (!button){
			return;
		}

		button.removeEventListener('click', handleObMiniCartSubmit);
		button.addEventListener('click', handleObMiniCartSubmit);
	});

	Object.keys(obMiniCartState.link).forEach((key) => {
		const link = document.getElementById(key);
		if (!link){
			return;
		}

		link.removeEventListener('click', handleObMiniCartSubmit);
		link.addEventListener('click', handleObMiniCartSubmit);
	});
});

document.addEventListener('mini-cart:rerender', () => {
	Object.keys(obMiniCartState.policies).forEach((key) => {
		const input = document.getElementById(key);
		if (!input) {
			return;
		}
		input.checked = obMiniCartState.policies[key];
		input.removeEventListener('click', handleObMiniCartCheckBox);
		input.addEventListener('click', handleObMiniCartCheckBox);
	});

	Object.keys(obMiniCartState.button).forEach((key) => {
		const button = document.getElementById(key);
		if (!button){
			return;
		}

		button.removeEventListener('click', handleObMiniCartSubmit);
		button.addEventListener('click', handleObMiniCartSubmit);

	});

	Object.keys(obMiniCartState.link).forEach((key) => {
		const link = document.getElementById(key);
		if (!link){
			return;
		}

		link.removeEventListener('click', handleObMiniCartSubmit);
		link.addEventListener('click', handleObMiniCartSubmit);

	});

	handleCartRecommendationsOnRerender();
});

// qc- In Cart Upsell & Cross Sell app - listens for cart changes and
// displays offer if conditions are met
document.addEventListener('cart:updated', function() {
	setTimeout(function () {
		InCartUpsell.prototype.findOfferWhenReady();  // eslint-disable-line
	}, 1000);
});